export const handleAppTypeHelper = (selectedOption) => {
  let apptype = [];
  selectedOption.forEach((info) => {
    apptype.push(info.label);
  });
  let updateDataQuery = {
    apptype: apptype.length > 0 ? apptype.join(",") : "all",
  };
  return updateDataQuery;
};
